import React from 'react'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import Container from '@mui/material/Container'
import Typography from '@mui/material/Typography'
import FooterNavigation from '../../components/footer/footer-navigation'
import FooterSocialLinks from '../../components/footer/footer-social-links'
import aryastackLogo from '../../assets/aryastack_icon.png'

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{ backgroundColor: '#fdf2f2', py: { xs: 6, md: 10 }, color: 'black' }}
    >
      <Container>
        <Grid container spacing={1}>
          <Grid item xs={12} md={5}>
            <Box sx={{ width: { xs: '100%', md: 360 }, mb: { xs: 3, md: 0 } }}>
              <Typography component="h2" variant="h2" sx={{ mb: 2 }}>
                VoiceTyping.xyz
              </Typography>
              <Typography variant="subtitle1" sx={{ letterSpacing: 1, mb: 2 }}>
                Our App - Voice Typing simplifies typing text and emojis in the browser with voice-to-text technology.
              </Typography>
              <FooterSocialLinks />
            </Box>
          </Grid>
          <Grid item xs={12} md={7}>
            <FooterNavigation />
          </Grid>
        </Grid>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 1,
            mt: 4,
            fontSize: '0.75rem',
            color: 'text.secondary'
          }}
        >
          <span>Built with ♥ by</span>
          <a
            href="https://aryastack.com"
            target="_blank"
            rel="noopener noreferrer"
            title="AryaStack Technologies — https://aryastack.com"
            aria-label="AryaStack Technologies"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '6px',
              borderRadius: '9999px',
              backgroundColor: '#ffffff',
              border: '1px solid rgba(0, 0, 0, 0.08)',
              padding: '4px 12px',
              fontSize: '0.75rem',
              fontWeight: 600,
              color: '#0B132B',
              boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
              textDecoration: 'none',
              transition: 'all 0.2s ease-in-out',
              cursor: 'pointer'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'scale(1.05)'
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'scale(1)'
            }}
          >
            <img
              src={aryastackLogo}
              alt="AryaStack Technologies"
              style={{
                height: '16px',
                width: 'auto',
                objectFit: 'contain',
                display: 'block',
                pointerEvents: 'none'
              }}
            />
            <span>AryaStack Technologies</span>
          </a>
        </Box>
      </Container>
    </Box>
  )
}

export default Footer
